import { Database } from 'src/app/shared/databases/database';
import { DatabaseWrapper } from 'src/app/shared/databases/database.wrapper';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class RestAPIWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);
        this.dbTyp_Id = DatabaseEnum.restAPI.ID;
        this.name = DatabaseEnum.restAPI.NAME;
        this.code = DatabaseEnum.restAPI.CODE;
        this.equivalentTag = DatabaseEnum.restAPI.EQUIVALENT_TAG;
        this.showRestPropertiesTab = false;
        this.showDatabaseTab = false;
        this.showLoadPropertiesTab = false;
        this.showExtractPropertiesTab = true;
        this.showRestPIParametersTab = true;

         //data object tabs
         this.showDataObjectPropertiesTab = true;
         this.showDDLOption = false;
         this.showViewDataTabOption = true;
         this.hideSchemaNmColumn = false;
         this.isShowObjProperties = true;
         this.dataObjectConnDatabaseNm = 'Database';
         this.getSchemasOnDbNm = false;
         this.isNeedRedirectForTestDP = true;
         this.showDataDescription = false;

    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {

        super.validateRepConn(repConnWrapper);

        if (repConnWrapper.repConn.conn.url == "") {
            repConnWrapper.inValid_Cds.push('RESTAPI_URL');
        }

       if (repConnWrapper.repConn.conn.secAuth == 'basic') {

            if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
                repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
            }

            if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
                repConnWrapper.inValid_Cds.push('NO_PASSWORD');
            }
        } else if (repConnWrapper.repConn.conn.secAuth == 'OAuth_2.0') {
            if (repConnWrapper.repConn.conn.access_Token_Flg == "N") {
                if(repConnWrapper.repConn.conn.accessToken == "") {
                    repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
                }
            }

            if (repConnWrapper.repConn.conn.access_Token_Flg == "Y") {
                if (repConnWrapper.repConn.conn.consumerKey == "") {
                    repConnWrapper.inValid_Cds.push('CONS_KEY');
                }

                if (repConnWrapper.repConn.conn.consumerSecret == "") {
                    repConnWrapper.inValid_Cds.push('CONS_SEC');
                }

                if (repConnWrapper.repConn.conn.hbase_Master_Port == "") {
                    repConnWrapper.inValid_Cds.push('HBASE_MASTER_PORT');
                }

                if (repConnWrapper.repConn.conn.hbase_Master_Host == "") {
                    repConnWrapper.inValid_Cds.push('HBASE_MASTER_HOST');
                }

                if (repConnWrapper.repConn.conn.connType == "") {
                    repConnWrapper.inValid_Cds.push('CONN_TYPE');
                }

                if (repConnWrapper.repConn.conn.ftpHost == "") {
                    repConnWrapper.inValid_Cds.push('FTPHOST');
                }

            }

        }

        // if (repConnWrapper.repConn.conn.flagent_Id == -1) {
        //     repConnWrapper.inValid_Cds.push('ESM00202');
        // }

        let restPropertiesIndex: number = repConnWrapper.repConn.rest_Properties.length;
        let propertyCds: Array<string> = new Array<string>();
        let count = 0;

        while (restPropertiesIndex--) {
            if (repConnWrapper.repConn.rest_Properties[restPropertiesIndex].property_Cd == '') {
                repConnWrapper.inValid_Cds.push("EMPTY_PARAMETERNAME");
                count++;
            } else {
                propertyCds.push(repConnWrapper.repConn.rest_Properties[restPropertiesIndex].property_Cd)
            }
        }

        let headerPropertiesIndex: number = repConnWrapper.repConn.header_Properties.length;

        while (headerPropertiesIndex--) {
            if (repConnWrapper.repConn.header_Properties[headerPropertiesIndex].property_Cd == '') {
                repConnWrapper.inValid_Cds.push("EMPTY_PARAMETERNAME");
                count++;
            } else {
                propertyCds.push(repConnWrapper.repConn.header_Properties[headerPropertiesIndex].property_Cd)
            }
        }

        if (propertyCds.length >= 2) {
            let hasDuplicate = propertyCds.some((val, i) => propertyCds.indexOf(val) !== i);
            if (hasDuplicate) {
                repConnWrapper.inValid_Cds.push("DUPLICATE_PARAMETERNAME");
            }
        }
    }


}
